import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FaApple, FaMicrosoft } from "react-icons/fa";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {API_URL} from "../../constants"


const SignUp = () => {
  const { type, job_id } = useParams();
  const navigate = useNavigate();
  const title = type === "candidate" ? "Candidate Signup" : "Recruiter Signup";
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    username: "",
    password: "",
    confirmPassword: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    // Client-side validation
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(API_URL+
        "authy/register", // Update with your backend URL
        {
          email: formData.email,
          username: "jjjoljkijih",
          password: formData.password,
          password2: formData.confirmPassword,
          account_type: "candidate", // Send the account type to backend
          job_id: job_id // Send the account type to backend


        }
      );
      console.log(type)
      console.log(response.data)
      if (response.data.token) {
        // Handle successful registration
        console.log("Registration successful:", response.data);
        localStorage.setItem("token", response.data.token)
        navigate(`/auth/verify/${response.data.pk}/`+job_id);
      } else {
        setError(response.data.error_message || "Registration failed");
      }
    } catch (err) {
      setError(err.response?.data?.error_message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl text-black font-semibold text-center mb-6">
          {title}
        </h2>

        <form className="space-y-4" onSubmit={handleSubmit}>
          {/* Email Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Email *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          {/* Password Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Password *
            </label>
            <input
              type="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleInputChange}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          {/* Confirm Password Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Confirm Password *
            </label>
            <input
              type="password"
              name="confirmPassword"
              placeholder="Re-enter your password"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-teal-600 text-white py-2 mt-4 rounded-md hover:bg-teal-700 transition"
          >
            Signup
          </button>
        </form>

        {/* OR Separator */}
        <div className="flex items-center my-4">
          <hr className="flex-grow border-gray-300" />
          <span className="px-2 text-gray-500 text-sm">OR</span>
          <hr className="flex-grow border-gray-300" />
        </div>

        {/* Social Logins */}
        <a href="http://127.0.0.1:8000/accounts/google/login/" className="w-full bg-black text-white py-2 rounded-md flex items-center justify-center gap-2 mb-2">
          <FcGoogle className="w-5 h-5" />
          Signup with Google
        </a>

        {/* Login Link */}
        <p className="text-center text-sm text-gray-600 mt-4">
          Already have an account?{" "}
          <span className="text-green-600 cursor-pointer">
            <Link to={`/auth/login/${type}`}>Login</Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
